export default __webpack_public_path__ + "static/1_4-84af555e12c260e6193735a85fd4eb1d.jpeg";